import { sha256 } from 'js-sha256';
import { useEffect, useState, useContext, createContext } from 'react';

const CORRECT_HASH = 'e849706c44d71df32e10c8358b460391fcc29620ccb57ed2c72820f22ce871a2'; // You, in my head

const AuthContext = createContext();

export const AuthProvider = ({children}) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  const login = (password) => {
    const hashed = sha256(password);
    if (hashed === CORRECT_HASH) {
      document.cookie = `auth=${hashed}; path=/; SameSite=Lax`;
      setIsAuthenticated(true);
      return true;
    }
    return false;
  }

  useEffect(() => {
    const cookies = document.cookie.split(';').map(c => c.trim());
    const authCookie = cookies.find(c => c.startsWith('auth='));
    if (authCookie) {
      const value = authCookie.split('=')[1];
      if (value === CORRECT_HASH) {
        setIsAuthenticated(true);
      }
    }
    setLoading(false);
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated, loading, login }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};